import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { translations } from './locales/translations';

const IP_LANG_KEY = 'viyero_language';
const IP_DETECTED_KEY = 'viyero_ip_detected';

const getInitialLanguage = () => {
  const saved = localStorage.getItem(IP_LANG_KEY);
  if (saved) return saved;
  return 'tr';
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: translations.en },
      tr: { translation: translations.tr }
    },
    lng: getInitialLanguage(),
    fallbackLng: 'tr',
    interpolation: { escapeValue: false }
  });

// Detect country from IP — only on first visit (no manual language choice yet)
const userManuallyChose = localStorage.getItem(IP_LANG_KEY);
const alreadyDetected = sessionStorage.getItem(IP_DETECTED_KEY);

if (!userManuallyChose && !alreadyDetected) {
  fetch('https://api.country.is/', { signal: AbortSignal.timeout(3000) })
    .then(res => res.json())
    .then(data => {
      sessionStorage.setItem(IP_DETECTED_KEY, '1');
      if (data.country === 'TR') {
        i18n.changeLanguage('tr');
      }
    })
    .catch(() => {});
}

export default i18n;
